import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  icon: IconDefinition;
  iconA11yLabel: string;
}>;

const FilterGroup = ({ icon, iconA11yLabel, children }: Props) => (
  <div className="filter-group" role="group" aria-label={iconA11yLabel}>
    <div className="filter-group-icon" aria-hidden>
      <FontAwesomeIcon icon={icon} fixedWidth />
    </div>
    {children}
  </div>
);

export default FilterGroup;
